
import React from 'react';
import '../asset/css/Switch.css';

const Switch = ({ isOn, id, handleToggle, disabled = false, ariaLabel = "Toggle status" }) => {
    return (
      <span className="app-switch">
        <input
          checked={isOn}
          onChange={handleToggle}
          className="react-switch-checkbox"
          id={id}
          type="checkbox"
          disabled={disabled}
          aria-label={ariaLabel}
        />
        <label
          className={`react-switch-label${isOn ? " is-on" : " is-off"}`}
          htmlFor={id}
        >
          <span className="react-switch-button" aria-hidden="true">
            <i className={`fas ${isOn ? "fa-check" : "fa-times"}`} />
          </span>
        </label>
      </span>
    );
  };
  
  export default Switch;
